import { QueryClient } from '@tanstack/react-query'

const FIVE_MINUTES = 1000 * 60 * 5 // in milliseconds

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: FIVE_MINUTES,
    },
  },
})
